/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'gatsby';
import { sample } from 'lodash-es';
import { setDataLayer } from '../../helpers/util';

import OptimizedImage from '../OptimizedImage';

const PHOTOS = [
  'cta_photo-cut.png',
  'banner_photo.png',
  'banner_photo1.png',
  'banner_photo2.png',
  'banner_photo3.png'
];

const BlogBanner = ({
  className,
  title,
  subtitle,
  showForm,
  versionBlog,
  location
}) => {
  const [rules, setRules] = useState(false);
  const [photo] = useState(sample(PHOTOS));
  const [email, setEmail] = useState('');
  const [submit, setSubmit] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [sending, setSending] = useState(false);

  const sendDataLayer = actionType => {
    const data = {
      event: 'formAction',
      formName: 'ulam-newsletter-form',
      formActionType: actionType
    };

    setDataLayer(data);
  };

  const submitInitialDataLayer = () => {
    if (!isDirty) {
      sendDataLayer('start');
    }
    setIsDirty(true);
  };

  const handleEmail = e => setEmail(e.target.value);

  const toggleCheckbox = () => {
    setRules(!rules);
  };

  const makeApiCall = async form => {
    const mailChimpBody = {
      form: form.getAttribute('name'),
      email,
      tags: ['newsletter'],
      signupSource: location
    };
    try {
      setSending(true);
      await axios.post('/api/mcSubscribe', mailChimpBody).then(response => {
        setValidationMsg(response.data);
      });
      setEmail('');
      setSubmit(false);
      sendDataLayer('submit_success');
    } catch (err) {
      setValidationMsg(err.response.data);
    } finally {
      setSending(false);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    const form = e.target;
    setSubmit(true);
    if (rules) makeApiCall(form);
  };

  return (
    <div className={`item banner banner-card ${className || ''}`}>
      <div className="banner-card__bg-container">
        <OptimizedImage src="banner_bg_image.png" className="content" />
      </div>
      <div className="content" style={{ overflow: 'hidden' }}>
        <span className={`banner-title ${versionBlog && 'small'}`}>
          {title}
        </span>
        <div className="divider" />
        <span className="banner-subtitle">{subtitle}</span>
        {showForm ? (
          <>
            <form
              className="banner-form banner-newsletter"
              name="ulam-newsletter-form"
              method="post"
              data-netlify="true"
              data-netlify-honeypot="bot-field"
              onSubmit={handleSubmit}
              onChange={submitInitialDataLayer}
            >
              <input
                type="hidden"
                name="form-name"
                value="ulam-newsletter-form"
              />
              <div className="banner-input-wrapper">
                <input
                  className="banner-input"
                  type="email"
                  name="email"
                  id="email"
                  value={email}
                  placeholder="Enter your email"
                  onChange={handleEmail}
                />
                <span
                  className={`${
                    validationMsg === 'Subscribed!'
                      ? 'succ-message'
                      : 'err-message'
                  }`}
                >
                  {validationMsg}
                </span>
                <div className="newsletter-check">
                  <div className="newsletter-check terms">
                    <input
                      checked={rules}
                      onChange={toggleCheckbox}
                      id="newsletter-checkbox"
                      type="checkbox"
                      className="newsletter-check checkbox"
                    />
                    <label
                      className="newsletter-check label"
                      htmlFor="newsletter-checkbox"
                    >
                      I accept the Terms of Service and I have read and agree to
                      the Privacy Policy
                    </label>
                  </div>
                  {submit && !rules && (
                    <div className="newsletter-check message">
                      Before sending us your data, be sure to read the{' '}
                      <Link
                        className="newsletter-check-link"
                        to="/privacy-policy/"
                      >
                        Privacy Policy
                      </Link>
                      , in which you will find information about the
                      administrator of your personal data, your rights, for
                      which your data is processed, for what period, who are the
                      recipients of your data and any other information that
                      relates to the protection of your personal data.
                    </div>
                  )}
                </div>
              </div>

              <button className="banner-btn" type="submit">
                {sending ? 'Loading...' : 'Subscribe'}
              </button>
            </form>
          </>
        ) : (
          <div>
            <Link
              style={{ boxShadow: 'none' }}
              to="/careers/"
              className="banner-btn jobBanner-btn"
            >
              Go to careers
            </Link>
          </div>
        )}
      </div>
      <div className="right">
        <OptimizedImage
          src={photo}
          title="banner image"
          alt="banner image"
          className=""
          imgStyle={{
            objectPosition: '0% 0%',
            minWidth: '100px'
          }}
        />
      </div>
    </div>
  );
};

export default BlogBanner;

BlogBanner.defaultProps = {
  title: 'Are you looking for a job?',
  subtitle: " Great, we're looking for tech-savvy people!"
};
